import { createGlobalStyle } from 'styled-components';
//
import { IThemeProps } from 'theme';

export default createGlobalStyle(({ theme }: IThemeProps) => {
  const { darkPanelBackground, disabledFont, fontBody, primary, white } = theme.primary.colors;
  const globalFontFamily =
    "Avenir Next, Nunito, Arial, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
  return {
    body: {
      backgroundColor: white,
      color: fontBody,
      fontFamily: globalFontFamily,
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      fontSize: 14,
      margin: 0,
    },
    input: {
      color: fontBody,
      fontFamily: globalFontFamily,
    },
    textarea: {
      color: fontBody,
    },
    a: {
      color: primary,
    },
    button: {
      fontFamily: globalFontFamily,
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
    },

    // Transparent scrollbars
    '::-webkit-scrollbar': {
      width: 8,
    },
    '::-webkit-scrollbar-thumb': {
      background: disabledFont,
      borderRadius: 4,
    },
    '::-webkit-scrollbar-track': {
      background: darkPanelBackground,
    },
  };
});
